const getEncodedImageUrl = (
  key,
  width,
  height,
  fit = "cover",
  background = {
    r: 255,
    g: 255,
    b: 255,
    alpha: 1
  }
) => {
  var body = {
    bucket: process.env.REACT_APP_ASSET_BUCKET,
    key: key,
    edits: {
      resize: {
        width,
        height,
        fit,
        background
      }
    }
  };
  var encodedUrl = `https://d1ouj6p32fel7e.cloudfront.net/${btoa(
    JSON.stringify(body)
  )}`;
  return encodedUrl;
};

export default getEncodedImageUrl;